export default "__VITE_ASSET__DjXBvQld__"